import React from "react";
import { CaretLeft } from "@phosphor-icons/react";
import CatIcon from "./CatIcon";
import { VAULT_SURFACE_STYLE } from "./vaultSchema";

/**
 * Shown when a user opens a category whose `live` flag is false. Currently
 * unused (all 8 categories are live in v1.3) but kept so future placeholder
 * categories can plug in cleanly.
 */
export default function PlaceholderCategory({ cat, onBack }) {
  return (
    <div
      className="px-5 pt-4 pb-28 min-h-screen bg-bone"
      style={VAULT_SURFACE_STYLE}
      data-testid={`category-${cat.id}-placeholder`}
    >
      <div className="flex items-center justify-between mb-5">
        <button
          type="button"
          onClick={onBack}
          aria-label="Back"
          className="w-10 h-10 rounded-full bg-white shadow-soft border border-navy/10 flex items-center justify-center"
        >
          <CaretLeft size={20} weight="bold" color="#0E2C54" />
        </button>
        <h2 className="font-jakarta font-extrabold text-navy text-xl flex items-center gap-2">
          <CatIcon cat={cat} size={22} />
          {cat.label}
        </h2>
        <div className="w-10 h-10" />
      </div>

      <div
        className="rounded-2xl p-8 text-center border"
        style={{ backgroundColor: cat.soft, borderColor: `${cat.color}22` }}
      >
        <div className="w-16 h-16 mx-auto rounded-2xl flex items-center justify-center mb-4 bg-white shadow-soft">
          <CatIcon cat={cat} size={32} />
        </div>
        <div className="font-jakarta font-extrabold text-navy text-2xl mb-2">
          {cat.label} — coming soon
        </div>
        <p className="text-navy-soft text-sm font-jakarta font-medium leading-relaxed max-w-[32ch] mx-auto">
          We're building this category next. Tap Settings → Help & feedback to
          tell us which fields you want first.
        </p>
      </div>

      <button
        type="button"
        onClick={onBack}
        className="w-full mt-5 bg-navy text-white font-jakarta font-extrabold text-base rounded-full py-3.5 shadow-soft"
      >
        Back to Vault
      </button>
    </div>
  );
}
